<template>
  <div
    class="chat-log"
    ref="chatLogContainer"
    v-bind:style="{ height: valorHeight + '%' }"
  >
   <message-bubble
    v-for="historyMsg in history"
    v-bind:key="historyMsg.COD_MENSAJE"
    v-bind:uuid="historyMsg.ID_ACTOR"
    v-bind:nombre="historyMsg.NOMBRE_ACTOR"
    v-bind:text="(historyMsg.TEXTO_MENSAJE === null ? '' : historyMsg.TEXTO_MENSAJE)"
    v-bind:imagen="(historyMsg.TIENE_ADJUNTO == 1 ? true : false)"
    v-bind:timetoken="historyMsg.FECHA_ENVIO"
    v-bind:adjunto_miniatura="historyMsg.ADJUNTO_MINIATURA"
    v-bind:contenido_adjunto="historyMsg.CONTENIDO_ADJUNTO"
    v-bind:history="historyMsg"

  ></message-bubble>

  <message-bubble
    v-for="msg in vueChatMsg"
    v-bind:key="msg.id"
    v-bind:uuid="msg.message.uuid"
    v-bind:nombre="msg.message.nombre"
    v-bind:text="msg.message.text"
    v-bind:imagen="msg.message.imagen"
    v-bind:timetoken="msg.message.timetoken"
  ></message-bubble>
  </div>
</template>

<script>
import MessageBubble from '@/components/chat/MessageBubble'
import { mapActions } from "vuex";

/**
 * Auto scrolls the chat log to the bottom when a new message is received
 */
function scrollBottom () {
  this.$el.scrollTo(0, this.$el.scrollHeight)
}

export default {
  name: 'chat-log',
  props: {
    idIncidencia: String
  },
  components: {MessageBubble},
  data () {
    return {
      /*
       * $pnGetMessage will listen to a channel subscribed to and start to
       * display messages as soon as they are received.
      */
      vueChatMsg: null
    }
  },
  watch: {
    vueChatMsg: function () {
      this.$nextTick(scrollBottom)
    },
    canal: async function () {

      this.vueChatMsg = null

      // Obtengo id de la incidencia a partir del canal
      let arrSplit = this.$store.state.chat.canal.toString().split("_");
      let idIncidencia = arrSplit[arrSplit.length - 1];

      // Descargamos los datos del chat a partir de la llamada al cupe.
      if (this.$store.state.chat.descargado === false) {

        const loader = this.$loading.show({
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false
        })

        await this.descargarChat(idIncidencia).then(
          () => {

            loader.hide()
          }
        );
        await this.marcarMensajesLeidos()
      }

      this.vueChatMsg = this.$pnGetMessage(this.canal)
      this.$nextTick(scrollBottom)
    }
  },
  mounted () {
    this.$store.commit('chat/setDescargado', false)
  },
  computed: {
    history () {
      this.$nextTick(scrollBottom)
      return this.$store.state.chat.chat
    },
    canal () {
      if (this.$store.state.chat.canal) {
        return this.$store.state.chat.canal
      }
      return 'vueChat'
    },
    valorHeight () {
      return (this.$route.name === 'chat') ? '80vh' : 98 // si estamos en el chat, el tamaño es mas grande
    }
  },
  methods: {
    ...mapActions({
      descargarChat: "chat/descargarChat",
      marcarMensajesLeidos: 'chat/marcarMensajesLeidos'
    })
  }
}
</script>

<style scoped>
.chat-log {
  display: block;
  height: 90%;
  width: auto;
  padding: 2% 4%;
  box-sizing: border-box;
  overflow-y: scroll;
  height: 90%;
}

.chat-log::-webkit-scrollbar {
  display: none;
}
</style>
